import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  sendTrackingEvent,
  toScreenEvent
} from '../../../services/amplitude.service'

import { APP_PATHS } from '../../AppRouter/types'
import { ApplicationOfferDeclined } from './ApplicationOfferDeclined.component'
import { OfferDeclinedScreenOpened } from './types'

/**
 * Container in case we want to react in the backend to declining
 * an offer, for now we log out
 * @returns
 */
export const ApplicationOfferDeclineContainer: React.FC = () => {
  const navigate = useNavigate()

  sendTrackingEvent(toScreenEvent({ ...OfferDeclinedScreenOpened }))

  const handleClick = (): void =>
    navigate(APP_PATHS.DOWNLOAD_APP, { replace: true })

  return <ApplicationOfferDeclined handleDone={handleClick} />
}
